import { C, F, maxW, trans } from './tokens';

export const SX = {
  // ─── Section label (accent bar + uppercase text) ─────────────────────────
  sectionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '.5rem',
    fontSize: '.68rem',
    fontWeight: 600,
    letterSpacing: '2.5px',
    textTransform: 'uppercase',
    color: C.textMuted,
    mb: '.9rem',
    '&::before': {
      content: '""',
      display: 'block',
      width: '22px',
      height: '1px',
      background: C.accent,
      flexShrink: 0,
    },
  },
  sectionLabelWhite: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '.5rem',
    fontSize: '.68rem',
    fontWeight: 600,
    letterSpacing: '2.5px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,.4)',
    mb: '.9rem',
    '&::before': {
      content: '""',
      display: 'block',
      width: '22px',
      height: '1px',
      background: C.accent,
      flexShrink: 0,
    },
  },

  // ─── Display titles ───────────────────────────────────────────────────────
  displayTitle: {
    fontFamily: F.display,
    fontSize: 'clamp(2.2rem, 4vw, 3.6rem)',
    fontWeight: 300,
    lineHeight: 1.12,
    color: C.text,
    '& em': { fontStyle: 'italic', color: C.accent },
  },
  displayTitleLg: {
    fontFamily: F.display,
    fontSize: 'clamp(2.8rem, 5.5vw, 5rem)',
    fontWeight: 300,
    lineHeight: 1.12,
    color: C.text,
    '& em': { fontStyle: 'italic', color: C.accent },
  },
  displayTitleWhite: {
    fontFamily: F.display,
    fontSize: 'clamp(2.2rem, 4vw, 3.6rem)',
    fontWeight: 300,
    lineHeight: 1.12,
    color: '#fff',
    '& em': { fontStyle: 'italic', color: 'rgba(255,255,255,.72)' },
  },

  // ─── Page hero ────────────────────────────────────────────────────────────
  pageHeroSection: {
    pt: '68px',
    backgroundColor: C.bg,
  },
  pageHeroInner: {
    maxWidth: maxW,
    mx: 'auto',
    px: { xs: '1rem', md: '2.5rem' },
    pt: { xs: '3.5rem', md: '4.5rem' },
    pb: { xs: '2.5rem', md: '3.5rem' },
  },
  pageHeroSub: {
    fontSize: '.95rem',
    color: C.textMuted,
    maxWidth: '540px',
    mt: '.75rem',
    lineHeight: 1.7,
    '& a': { color: C.primary, '&:hover': { color: C.accent } },
  },

  // ─── Generic inner container ──────────────────────────────────────────────
  sectionInner: {
    maxWidth: maxW,
    mx: 'auto',
    px: { xs: '1rem', md: '2.5rem' },
  },

  // ─── Buttons ─────────────────────────────────────────────────────────────
  btnDark: {
    display: 'inline-block',
    padding: '.72rem 1.6rem',
    fontSize: '.84rem',
    fontWeight: 500,
    borderRadius: '50px',
    transition: `all ${trans}`,
    cursor: 'pointer',
    background: C.dark,
    color: '#fff',
    textDecoration: 'none',
    '&:hover': { background: C.primary, color: '#fff', transform: 'translateY(-1px)' },
  },
  btnAccent: {
    display: 'inline-block',
    padding: '.72rem 1.6rem',
    fontSize: '.84rem',
    fontWeight: 500,
    borderRadius: '50px',
    transition: `all ${trans}`,
    cursor: 'pointer',
    background: C.accent,
    color: '#fff',
    textDecoration: 'none',
    '&:hover': { background: '#b05540', color: '#fff', transform: 'translateY(-1px)' },
  },
  btnOutline: {
    display: 'inline-block',
    padding: '.72rem 1.6rem',
    fontSize: '.84rem',
    fontWeight: 500,
    borderRadius: '50px',
    transition: `all ${trans}`,
    cursor: 'pointer',
    background: 'transparent',
    border: `1.5px solid ${C.text}`,
    color: C.text,
    textDecoration: 'none',
    '&:hover': { background: C.text, color: '#fff' },
  },
  btnOutlineWhite: {
    display: 'inline-block',
    padding: '.72rem 1.6rem',
    fontSize: '.84rem',
    fontWeight: 500,
    borderRadius: '50px',
    transition: `all ${trans}`,
    cursor: 'pointer',
    background: 'transparent',
    border: '1.5px solid rgba(255,255,255,.5)',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': { background: 'rgba(255,255,255,.12)', color: '#fff' },
  },
};
